module.exports = __webpack_public_path__ + "static/media/bnr1.823f624b.jpg";